const validatePhone = (rule, value, callback) => {
  if (value) {
    if (!/^1[3456789]\d{9}$/.test(value)) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }
}


export function visitDeclareConfig() {
  return {
    labelWidth: 160,
    emptyBtn: false,
    submitBtn: false,
    group: [
      {
        label: "走访基本信息",
        prop: "group1",
        column: [
          {
            label: "走访时间",
            prop: "visitDate",
            type: "date",
            format:'yyyy-MM-dd',
            valueFormat:'yyyy-MM-dd',
            rules: [{
              required: true,
              message: "请选择拜访时间",
              trigger: "blur",
            }, ],
          },
          {
            label: '随同走访人员',
            prop: 'visitPeople',
            placeholder: '请输入内容',
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入内容',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '联合走访单位',
            prop: 'visitDept',
            placeholder: '请输入内容',
            span: 24,
          },
          {
            label: '意见建议',
            prop: 'suggestion',
            placeholder: '请输入内容',
            span: 24,
            type:'textarea',
            maxlength:500,
            showWordLimit:true,
           
          }
        ],
      },
      {
        label: "走访企业信息",
        prop: "group2",

        column: [
          {
            label: '企业名称',
            prop: 'visitEntName',
            placeholder: '请输入内容',
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入内容',
                trigger: 'blur'
              }
            ]
          },
          {
            label: "行业地位",
            prop: "entPosition",
            placeholder: '请选择',
            span: 12,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=zs_project_type",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            type: "select",
          },
          {
            label: '年产值',
            prop: 'entProdVal',
            placeholder: '请输入内容',
            span: 12,
            formslot:true
          },
          {
            label: '年纳税额',
            prop: 'entTaxVal',
            placeholder: '请输入内容',
            span: 12,
            formslot:true
          },
          {
            label: '科技含量',
            prop: 'entTechVal',
            placeholder: '请输入内容',
            span: 12,
            
          },
          {
            label: '重点市场',
            prop: 'entImpMarket',
            placeholder: '请输入内容',
            span: 12,
            
          },
          {
            label: '对接联系人',
            prop: 'visitContractPerson',
            placeholder: '请输入内容',
            span: 24,
            formslot:true
            
          },{
            label: '企业简介',
            prop: 'entIntro',
            placeholder: '请输入内容',
            span: 24,
            type:'textarea',
            maxlength:500,
            showWordLimit:true,
            
          }
        ],
      },
      {
        label: "近期投资计划",
        prop: "group3",
        column: [
          {
            label: '投资意向',
            prop: 'investInten',
            type: 'radio',
            value:1,
            dicData: [{
              label: '有',
              value: 1
            }, {
              label: '没有',
              value: 0
            }],
            display:true,
            rules: [
              {
                required: true,
                message: '请选择',
                trigger: 'blur'
              }
            ]
          },
          {
          label: '项目概况',
          prop: 'projectIntro',
          placeholder: '请输入内容',
          span: 24,
          type:'textarea',
          maxlength:500,
          showWordLimit:true,
          display:true,
          rules: [
            {
              required: true,
              message: '请输入内容',
              trigger: 'blur'
            }
          ]
          
        },
        {
          label: "项目类型",
          prop: "projectType",
          placeholder: '请选择',
          span: 12,
          dicUrl: "/api/blade-system/dict-biz/dictionary?code=zs_project_type",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          type: "select",
          display:true,
        },{
          label: '投资规模',
          prop: 'investVal',
          placeholder: '请输入内容',
          span: 12,
          formslot:true,
          display:true,
          rules: [
            {
              required: true,
              message: '请输入内容',
              trigger: 'blur'
            }
          ]
          
        }],
      },
      
    ],
  }
}

export function addPersonFormConfig() {
  return {
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: '姓名',
        prop: 'name',
        span: 24,
        rules: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          } 
        ]
      }, {
        label: '联系电话',
        prop: 'phone',
        span: 24,
        rules: [
          {
            required: true,
            // message: '请输入联系电话',
            validator: validatePhone,
            trigger: 'blur'
          } 
        ]
      }, {
        label: '职务',
        prop: 'job',
        span: 24,
        rules: [
          {
            required: true,
            message: '请输入职务',
            trigger: 'blur'
          } 
        ]
      }
    ]
  }
}